import Bloc from './Bloc.js';
import Trigger from './Trigger.js';
import Data from './Data.js';

import Play from './Play.js';
import Pattern from './Pattern.js';
import Listener from './Listener.js';
import Compute from './Compute.js';
import Evanescence from './Evanescence.js';
import FlipBonus from './FlipBonus.js';

import Draw from './Draw.js';
import Send from './Send.js';
import Conjure from './Conjure.js';
import Shuffle from './Shuffle.js';
import ShuffleSupply from './ShuffleSupply.js';
import ShuffleDiscard from './ShuffleDiscard.js';
import Summon from './Summon.js';
import Discard from './Discard.js';
import Exile from './Exile.js';
import Cast from './Cast.js';
import Damage from './Damage.js';
import SplitDamage from './SplitDamage.js';
import Kill from './Kill.js';
import Block from './Block.js';
import LoseBlock from './LoseBlock.js';
import LoseLife from './LoseLife.js';
import Heal from './Heal.js';
import Apply from './Apply.js';
import SwitchStances from './SwitchStances.js';
import TurnForward from './TurnForward.js';
import TurnBack from './TurnBack.js';
import ChangeMana from './ChangeMana.js';
import ShiftMana from './ShiftMana.js';
import TempShiftMana from './TempShiftMana.js';
import AddMana from './AddMana.js';
import UseMana from './UseMana.js';
import GainGold from './GainGold.js';
import GainMaxHp from './GainMaxHp.js';
import GainCorruption from './GainCorruption.js';
import Curse from './Curse.js';
import LoseGold from './LoseGold.js';
import LoseCorruption from './LoseCorruption.js';
import GainExp from './GainExp.js';
import Growth from './Growth.js';
import Shrinkage from './Shrinkage.js';
import Morph from './Morph.js';
import HandChoice from './HandChoice.js';
import Dissipate from './Dissipate.js';
import DissipateStatus from './DissipateStatus.js';
import LoseIntent from './LoseIntent.js';
import ReviveCleanup from './ReviveCleanup.js';
import AddProperty from './AddProperty.js';
import TriggerEffect from './TriggerEffect.js';
import ExtraTrigger from './ExtraTrigger.js';
import Potion from './Potion.js';

import CountCards from './CountCards.js';
import CountEnemies from './CountEnemies.js';
import CheckCard from './CheckCard.js';
import CheckEntity from './CheckEntity.js';
import CheckStatus from './CheckStatus.js';
import CompareCards from './CompareCards.js';
import CompareModels from './CompareModels.js';
import CompareEntities from './CompareEntities.js';
import CompareLocations from './CompareLocations.js';
import CompareStatuses from './CompareStatuses.js';
import FilterProperty from './FilterProperty.js';
import FilterVariable from './FilterVariable.js';
import FilterCard from './FilterCard.js';
import FilterType from './FilterType.js';
import FilterModel from './FilterModel.js';
import FilterStats from './FilterStats.js';
import FilterOnSide from './FilterOnSide.js';
import FilterSideOf from './FilterSideOf.js';
import FilterSideFromPlay from './FilterSideFromPlay.js';
import FilterAdjacentFromPlay from './FilterAdjacentFromPlay.js';
import FilterPlayFromSide from './FilterPlayFromSide.js';
import MergeCardFilters from './MergeCardFilters.js';
import ReverseCardFilter from './ReverseCardFilter.js';
import MergeEntityFilters from './MergeEntityFilters.js';

import Highlander from './Highlander.js';
import Companion from './Companion.js';
import Timestamp from './Timestamp.js';
import Value from './Value.js';
import Passive from './Passive.js';
import Floor from './Floor.js';
import MazePower from './MazePower.js';
import Time from './Time.js';
import Corruption from './Corruption.js';
import CorruptActive from './CorruptActive.js';
import Gold from './Gold.js';
import Entropy from './Entropy.js';
import DeckSize from './DeckSize.js';
import Category from './Category.js';
import Mana from './Mana.js';
import OvergrowthBonus from './OvergrowthBonus.js';
import TurnCount from './TurnCount.js';
import HasStatus from './HasStatus.js';
import StatusValue from './StatusValue.js';
import GetBlock from './GetBlock.js';
import IsPlaying from './IsPlaying.js';
import Analyse from './Analyse.js';
import RandomInt from './RandomInt.js';
import RandomBool from './RandomBool.js';

import BreakCard from './BreakCard.js';
import BreakEntity from './BreakEntity.js';
import BreakChampion from './BreakChampion.js';

import FindCard from './FindCard.js';
import FindEnemy from './FindEnemy.js';
import FindModel from './FindModel.js';
import ExtremumEnemy from './ExtremumEnemy.js';

import SetStatValue from './SetStatValue.js';
import StatValue from './StatValue.js';
import StoreInteger from './StoreInteger.js';
import IntVariable from './IntVariable.js';
import StoreCard from './StoreCard.js';
import StoreModel from './StoreModel.js';
import ClearVariable from './ClearVariable.js';
import CardVariable from './CardVariable.js';
import ModelVariable from './ModelVariable.js';
import StoreGlobalInteger from './StoreGlobalInteger.js';
import GlobalIntVariable from './GlobalIntVariable.js';
import ClearGlobalVariable from './ClearGlobalVariable.js';

import EndTurn from './EndTurn.js';

import If from './If.js';
import Loop from './Loop.js';
import ForEachCard from './ForEachCard.js';
import ForEachEnemy from './ForEachEnemy.js';
import ForEachEffect from './ForEachEffect.js';
import ForEachEvent from './ForEachEvent.js';
import ForEachStatus from './ForEachStatus.js';

import Plus from './Plus.js';
import Minus from './Minus.js';
import Times from './Times.js';
import Div from './Div.js';
import Mod from './Mod.js';
import Not from './Not.js';
import And from './And.js';
import Or from './Or.js';
import Xor from './Xor.js';
import Ternary from './Ternary.js';
import Equal from './Equal.js';
import NotEqual from './NotEqual.js';
import Greater from './Greater.js';
import GreaterEqual from './GreaterEqual.js';
import Lesser from './Lesser.js';
import LesserEqual from './LesserEqual.js';
import Max from './Max.js';
import Min from './Min.js';
import Pow from './Pow.js';

import InnerData from './InnerData.js';

import RunAway from './RunAway.js';

import Wait from './Wait.js';
import Animation from './Animation.js';

export default class Reader {

	static read (blueprint, card) {

		var ctx = { triggers: [], actions: [], parameters: [] };
		Object.keys(ctx).forEach(key => blueprint[key].forEach((el,i) => {
			var bloc = null;
			switch(el.type) {

			case "play": bloc = new Play(card, ctx); break;
			case "pattern": bloc = new Pattern(card, ctx); break;
			case "listener": bloc = new Listener(card, ctx); break;
			case "compute": bloc = new Compute(card, ctx); break;
			case "evanescence": bloc = new Evanescence(card, ctx); break;
			case "flipbonus": bloc = new FlipBonus(card, ctx); break;

			case "draw": bloc = new Draw(card, ctx); break;
			case "send": bloc = new Send(card, ctx); break;
			case "conjure": bloc = new Conjure(card, ctx); break;
			case "shuffle": bloc = new Shuffle(card, ctx); break;
			case "shufflesupply": bloc = new ShuffleSupply(card, ctx); break;
			case "shufflediscard": bloc = new ShuffleDiscard(card, ctx); break;
			case "summon": bloc = new Summon(card, ctx); break;
			case "discard": bloc = new Discard(card, ctx); break;
			case "exile": bloc = new Exile(card, ctx); break;
			case "cast": bloc = new Cast(card, ctx); break;
			case "damage": bloc = new Damage(card, ctx); break;
			case "splitdamage": bloc = new SplitDamage(card, ctx); break;
			case "kill": bloc = new Kill(card, ctx); break;
			case "block": bloc = new Block(card, ctx); break;
			case "loseblock": bloc = new LoseBlock(card, ctx); break;
			case "lifeloss": bloc = new LoseLife(card, ctx); break;
			case "heal": bloc = new Heal(card, ctx); break;
			case "stance": bloc = new SwitchStances(card, ctx); break;
			case "turnforward": bloc = new TurnForward(card, ctx); break;
			case "turnback": bloc = new TurnBack(card, ctx); break;
			case "applystatus": bloc = new Apply(card, ctx); break;
			case "changemana": bloc = new ChangeMana(card, ctx); break;
			case "shiftmana": bloc = new ShiftMana(card, ctx); break;
			case "tempshiftmana": bloc = new TempShiftMana(card, ctx); break;
			case "addmana": bloc = new AddMana(card, ctx); break;
			case "usemana": bloc = new UseMana(card, ctx); break;
			case "gaingold": bloc = new GainGold(card, ctx); break;
			case "gainmaxhp": bloc = new GainMaxHp(card, ctx); break;
			case "gaincorruption": bloc = new GainCorruption(card, ctx); break;
			case "curse": bloc = new Curse(card, ctx); break;
			case "gainexp": bloc = new GainExp(card, ctx); break;
			case "losegold": bloc = new LoseGold(card, ctx); break;
			case "losecorruption": bloc = new LoseCorruption(card, ctx); break;
			case "morph": bloc = new Morph(card, ctx); break;
			case "growth": bloc = new Growth(card, ctx); break;
			case "shrinkage": bloc = new Shrinkage(card, ctx); break;
			case "handchoice": bloc = new HandChoice(card, ctx); break;
			case "dissipate": bloc = new Dissipate(card, ctx); break;
			case "dissipatestatus": bloc = new DissipateStatus(card, ctx); break;
			case "loseintent": bloc = new LoseIntent(card, ctx); break;
			case "revivecleanup": bloc = new ReviveCleanup(card, ctx); break;
			case "addproperty": bloc = new AddProperty(card, ctx); break;
			case "trigger": bloc = new TriggerEffect(card, ctx); break;
			case "extratrigger": bloc = new ExtraTrigger(card, ctx); break;
			case "potion": bloc = new Potion(card, ctx); break;

			case "countcards": bloc = new CountCards(card, ctx); break;
			case "countenemies": bloc = new CountEnemies(card, ctx); break;
			case "checkcard": bloc = new CheckCard(card, ctx); break;
			case "checkentity": bloc = new CheckEntity(card, ctx); break;
			case "checkstatus": bloc = new CheckStatus(card, ctx); break;
			case "cmpcards": bloc = new CompareCards(card, ctx); break;
			case "cmpmodels": bloc = new CompareModels(card, ctx); break;
			case "cmpentities": bloc = new CompareEntities(card, ctx); break;
			case "cmplocations": bloc = new CompareLocations(card, ctx); break;
			case "cmpstatuses": bloc = new CompareStatuses(card, ctx); break;
			case "filterproperty": bloc = new FilterProperty(card, ctx); break;
			case "filtervar": bloc = new FilterVariable(card, ctx); break;
			case "filtercard": bloc = new FilterCard(card, ctx); break;
			case "filtertype": bloc = new FilterType(card, ctx); break;
			case "filtermodel": bloc = new FilterModel(card, ctx); break;
			case "filterstats": bloc = new FilterStats(card, ctx); break;
			case "filteronside": bloc = new FilterOnSide(card, ctx); break;
			case "filtersideof": bloc = new FilterSideOf(card, ctx); break;
			case "filtersidefromplay": bloc = new FilterSideFromPlay(card, ctx); break;
			case "filteradjfromplay": bloc = new FilterAdjacentFromPlay(card, ctx); break;
			case "filterplayfromside": bloc = new FilterPlayFromSide(card, ctx); break;
			case "mergecfilters": bloc = new MergeCardFilters(card, ctx); break;
			case "revcfilter": bloc = new ReverseCardFilter(card, ctx); break;
			case "mergeefilters": bloc = new MergeEntityFilters(card, ctx); break;

			case "highlander": bloc = new Highlander(card, ctx); break;
			case "companion": bloc = new Companion(card, ctx); break;
			case "timestamp": bloc = new Timestamp(card, ctx); break;
			case "passive": bloc = new Passive(card, ctx); break;
			case "floor": bloc = new Floor(card, ctx); break;
			case "mazepower": bloc = new MazePower(card, ctx); break;
			case "time": bloc = new Time(card, ctx); break;
			case "value": bloc = new Value(card, ctx); break;
			case "corruption": bloc = new Corruption(card, ctx); break;
			case "corruptactive": bloc = new CorruptActive(card, ctx); break;
			case "gold": bloc = new Gold(card, ctx); break;
			case "entropy": bloc = new Entropy(card, ctx); break;
			case "decksize": bloc = new DeckSize(card, ctx); break;
			case "category": bloc = new Category(card, ctx); break;
			case "mana": bloc = new Mana(card, ctx); break;
			case "overgrowthbonus": bloc = new OvergrowthBonus(card, ctx); break;
			case "turncount": bloc = new TurnCount(card, ctx); break;
			case "hasstatus": bloc = new HasStatus(card, ctx); break;
			case "statusvalue": bloc = new StatusValue(card, ctx); break;
			case "getblock": bloc = new GetBlock(card, ctx); break;
			case "isplaying": bloc = new IsPlaying(card, ctx); break;
			case "analyse": bloc = new Analyse(card, ctx); break;
			case "randint": bloc = new RandomInt(card, ctx); break;
			case "randbool": bloc = new RandomBool(card, ctx); break;

			case "endturn": bloc = new EndTurn(card, ctx); break;

			case "breakcard": bloc = new BreakCard(card, ctx); break;
			case "breakentity": bloc = new BreakEntity(card, ctx); break;
			case "breakchampion": bloc = new BreakChampion(card, ctx); break;

			case "findcard": bloc = new FindCard(card, ctx); break;
			case "findenemy": bloc = new FindEnemy(card, ctx); break;
			case "findmodel": bloc = new FindModel(card, ctx); break;
			case "extremumenemy": bloc = new ExtremumEnemy(card, ctx); break;

			case "setstatvalue": bloc = new SetStatValue(card, ctx); break;
			case "statvalue": bloc = new StatValue(card, ctx); break;
			case "writeintvar": bloc = new StoreInteger(card, ctx); break;
			case "intvar": bloc = new IntVariable(card, ctx); break;
			case "writecardvar": bloc = new StoreCard(card, ctx); break;
			case "cardvar": bloc = new CardVariable(card, ctx); break;
			case "writemodelvar": bloc = new StoreModel(card, ctx); break;
			case "modelvar": bloc = new ModelVariable(card, ctx); break;
			case "writeintfvar": bloc = new StoreGlobalInteger(card, ctx); break;
			case "intfvar": bloc = new GlobalIntVariable(card, ctx); break;
			case "clearvar": bloc = new ClearVariable(card, ctx); break;
			case "clearfvar": bloc = new ClearGlobalVariable(card, ctx); break;

			case "if": bloc = new If(card, ctx); break;
			case "loop": bloc = new Loop(card, ctx); break;
			case "forcard": bloc = new ForEachCard(card, ctx); break;
			case "forenemy": bloc = new ForEachEnemy(card, ctx); break;
			case "forevent": bloc = new ForEachEvent(card, ctx); break;
			case "forstatus": bloc = new ForEachStatus(card, ctx); break;
			case "foreffect": bloc = new ForEachEffect(card, ctx); break;

			case "opplus": bloc = new Plus(card, ctx); break;
			case "opminus": bloc = new Minus(card, ctx); break;
			case "optimes": bloc = new Times(card, ctx); break;
			case "opdiv": bloc = new Div(card, ctx); break;
			case "opmod": bloc = new Mod(card, ctx); break;
			case "opnot": bloc = new Not(card, ctx); break;
			case "opand": bloc = new And(card, ctx); break;
			case "opor": bloc = new Or(card, ctx); break;
			case "opxor": bloc = new Xor(card, ctx); break;
			case "opter": bloc = new Ternary(card, ctx); break;
			case "ope": bloc = new Equal(card, ctx); break;
			case "opne": bloc = new NotEqual(card, ctx); break;
			case "opg": bloc = new Greater(card, ctx); break;
			case "opge": bloc = new GreaterEqual(card, ctx); break;
			case "opl": bloc = new Lesser(card, ctx); break;
			case "ople": bloc = new LesserEqual(card, ctx); break;
			case "opmax": bloc = new Max(card, ctx); break;
			case "opmin": bloc = new Min(card, ctx); break;
			case "oppow": bloc = new Pow(card, ctx); break;

			case "innerdata": bloc = new InnerData(card, ctx); break;

			case "runaway": bloc = new RunAway(card, ctx); break;

			case "wait": bloc = new Wait(card, ctx); break;
			case "animation": bloc = new Animation(card, ctx); break;

			case "play-trigger": bloc = new Trigger(el.type, card, ctx, "cast"); break;
			case "play-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[2], data[1], data[1]]); break;
			case "send-trigger": bloc = new Trigger(el.type, card, ctx, "movecard"); break;
			case "send-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[1], data[2]]); break;
			case "draw-trigger": bloc = new Trigger(el.type, card, ctx, "draw"); break;
			case "draw-data": bloc = new Data(el.type, card, ctx, data => [data[1]]); break;
			case "usemana-trigger": bloc = new Trigger(el.type, card, ctx, "paymana"); break;
			case "usemana-data": bloc = new Data(el.type, card, ctx, data => [data[1]]); break;
			case "damage-trigger": bloc = new Trigger(el.type, card, ctx, "damage"); break;
			case "damage-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[1], data[2], 0, data[3]]); break;
			case "block-trigger": bloc = new Trigger(el.type, card, ctx, "blockgain"); break;
			case "block-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[1], data[2]]); break;
			case "discard-trigger": bloc = new Trigger(el.type, card, ctx, "discard"); break;
			case "discard-data": bloc = new Data(el.type, card, ctx, data => [data[0]]); break;
			case "applystatus-trigger": bloc = new Trigger(el.type, card, ctx, "applystatus"); break;
			case "applystatus-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[1], data[2], data[3]]); break;
			case "lifeloss-trigger": bloc = new Trigger(el.type, card, ctx, "lifeloss"); break;
			case "lifeloss-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[1], data[2]]); break;
			case "morph-trigger": bloc = new Trigger(el.type, card, ctx, "cardmorph"); break;
			case "morph-data": bloc = new Data(el.type, card, ctx, data => [data[0], data[1], data[2]]); break;
			case "potion-trigger": bloc = new Trigger(el.type, card, ctx, "drinkpotion"); break;
			case "potion-data": bloc = new Data(el.type, card, ctx, data => []); break;
			case "turnforward-trigger": bloc = new Trigger(el.type, card, ctx, "turnforward"); break;
			case "turnforward-data": bloc = new Data(el.type, card, ctx, data => []); break;
			case "turnback-trigger": bloc = new Trigger(el.type, card, ctx, "turnback"); break;
			case "turnback-data": bloc = new Data(el.type, card, ctx, data => []); break;

			default: bloc = new Bloc(el.type, card, ctx); break;
			}
			ctx[key].push(bloc);
		}));
		Object.keys(ctx).forEach(key => blueprint[key].forEach((el, i) => {
			var bloc = ctx[key][i];
			bloc.updateIn(el.in);
		}));
		ctx.blueprint = blueprint;
		blueprint.triggers.forEach((trigger, i) => {
			var bloc = ctx.triggers[i];
			bloc.prepare(trigger, blueprint);
		})
		blueprint.basis.forEach(basis => {
			var bloc = ctx[basis.type][basis.index];
			bloc.setup(card);
		})
	}
}
